import { useState, useEffect } from "react";
import { supabase } from "@/lib/supabase";
import type { ChartData, DailyCheckIn } from "../types";
import { calculateChartData } from "../utils";

export const useChartData = (userId: string | undefined) => {
	const [chartData, setChartData] = useState<ChartData[]>([]);

	useEffect(() => {
		const fetchChartData = async () => {
			try {
				if (!userId) return;

				const { data, error } = await supabase
					.from("daily_checkins")
					.select("*, reflection:reflections(id, title, description)")
					.eq("user_id", userId)
					.order("created_at", { ascending: true });

				if (error) throw error;

				if (data) {
					const rawCheckIns = data as DailyCheckIn[];
					const calculatedChartData = calculateChartData(rawCheckIns);
					// Only show the last 30 check-ins on the chart
					const last30Data = calculatedChartData.slice(-30);
					setChartData(last30Data);
				}
			} catch (error: any) {
				console.error("Error fetching chart data:", error);
			}
		};

		fetchChartData();
	}, [userId]);

	return chartData;
};
